/** @jsx jsx */
import { Box } from "@eworkit/iris";
import { FC, useMemo } from "react";
import { jsx } from "theme-ui";

import { RoutedTabPanels } from "@/router/RoutedTabPanels";
import { ClientPageDetailsTab } from "@/views/Clients/Details/ClientPageDetailsTab";
import { ClientPageJobsTab } from "@/views/Clients/Jobs/ClientPageJobsTab";
import { ClientPageNewsTab } from "@/views/Clients/News/ClientPageNewsTab";

import { IClientPageNavigationTabsProps } from "./ClientPageNavigationTabs";

export const ClientPageNavigationTabPanels: FC<IClientPageNavigationTabsProps> = ({ publicProfile, isPublic }) => {
  const tabPanels = useMemo(
    () => ({
      details: () => <ClientPageDetailsTab publicProfile={publicProfile} isPublic={isPublic} />,
      jobs: () => <ClientPageJobsTab isPublic={isPublic} publicProfileIds={[publicProfile.id]} />,
      // NOTE: this feature is temporarily hidden
      // location: () => (
      //   <ClientPageLocationTab
      //     locations={[...(publicProfile.legalEntities ?? []).map(legalEntity => legalEntity)]}
      //     hqCountry={publicProfile.legalEntities.find(l => l.headquarter)?.country}
      //   />
      // ),
      news: () => <ClientPageNewsTab publicProfile={publicProfile} isPublic={isPublic} />,
    }),
    [publicProfile.id],
  );

  return (
    <Box pt={["sm", null, null, "md"]} pb="xxl" backgroundColor={isPublic ? "n0" : undefined}>
      <RoutedTabPanels routeParam="tab" views={tabPanels} />
    </Box>
  );
};
